import { render, staticRenderFns } from "./ColorPickerContainer.vue?vue&type=template&id=03da6d80&scoped=true&"
import script from "./ColorPickerContainer.vue?vue&type=script&lang=js&"
export * from "./ColorPickerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da6d80",
  null
  
)

export default component.exports